import { Outlet } from 'react-router-dom';

const MyEquipmentRequestsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
}

export default MyEquipmentRequestsPage;